import { BodyText } from "@/components/ui";
import { useParticipantProperty } from "@daily-co/daily-react";
import { AudioLines } from "lucide-react";
import {
  TRANSLATOR_AUDIO_ONLY_DISPLAY_NAME,
  TRANSLATOR_DISPLAY_NAME,
} from "../utils/translatorOptions";
import { CallPanelTile } from "./CallPanelTile";

interface TranslatorTileProps {
  participantId: string;
}

// Placeholder graphic until we have a design for the interpreter tile
const TranslatorPlaceholder = ({ audioOnly }: { audioOnly: boolean }) => (
  <div className="flex h-full min-h-[75px] w-full flex-col items-center justify-center gap-1 bg-black p-1 text-center">
    {audioOnly && <AudioLines size={16} className="text-white" />}
    <BodyText size="xs" textColor="white" bold>
      {TRANSLATOR_DISPLAY_NAME}
    </BodyText>
    {audioOnly && (
      <BodyText size="xs" textColor="white">
        Audio only
      </BodyText>
    )}
  </div>
);

export const TranslatorTile = ({ participantId }: TranslatorTileProps) => {
  // The dial-out sets the interpreter's display name to mark audio-only
  const userName = useParticipantProperty(participantId, "user_name");
  const audioOnly = userName === TRANSLATOR_AUDIO_ONLY_DISPLAY_NAME;

  return (
    <CallPanelTile
      participantId={participantId}
      placeholder={<TranslatorPlaceholder audioOnly={audioOnly} />}
      hideVideoMessage={audioOnly}
    />
  );
};
